/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import BankAccountService from "../../service/bank-account-service.js";
import BankService from "../../service/bank-service.js";
import PartyService from "../../service/party-service.js";

const bankAccountService = new BankAccountService();
const bankService = new BankService();
const partyService = new PartyService();

await loadDictionary('bank-account-edit-party-bank-account-window');

function EditPartyBankAccountWindow({openWindow, setOpenWindow, editBankAccountId, reloadList}) {
  const [partyId, setPartyId] = useState(null);
  const [id, setId] = useState(0);
  const [name, setName] = useState('');
  const [bankId, setBankId] = useState(null);
  const [type, setType] = useState('');
  const [accountNumber, setAccountNumber] = useState();
  const [iban, setIban] = useState();
  const [cardNumber, setCardNumber] = useState('');
  const [bankOptions, setBankOptions] = useState([]);
  const [partyOptions, setPartyOptions] = useState([]);

  const closeWindow = () => {
    setOpenWindow(false);
    
    setPartyId(null);
    setId(0);
    setName('');
    setBankId(null);
    setType('');
    setAccountNumber('');
    setIban('');
    setCardNumber('');
  };

  const checkIBAN = () => {
    bankAccountService.ibanInfo(iban).then(result => {
      setAccountNumber(result.account_number);
      setName(result.name.trim());
      setBankId(result.bank_id);
      setType(result.type);
    }).catch(error => {
      console.log(error);
    });
  };
  
  const save = () => {
    const bankAccount = {
      id: parseInt(id),
      name: name,
      party_id: parseInt(partyId),
      bank_id: parseInt(bankId),
      financial_channel_id: null,
      type: type,
      account_number: accountNumber,
      iban: iban,
      card_number: cardNumber,
      accounting_number: null
    };

    bankAccountService.edit(bankAccount).then(result => {
      if(result) {
        closeWindow();
        reloadList();
      }
    }).catch(error => {
      console.error(error);
    });
  }

  useEffect(() => {
    if(editBankAccountId) {
      bankService.findAll().then(banks => {
        const options = banks.map((bank) => <option key={bank.id} value={bank.id}>{bank.name}</option>);

        setBankOptions(options);
      });

      partyService.findAll().then(parties => {
        const options = parties.map((party) => <option key={party.id} value={party.id}>{party.name}</option>);

        setPartyOptions(options);
      });

      bankAccountService.findOne(editBankAccountId).then(bankAccount => {
          if(bankAccount) {
              setId(bankAccount.id);
              setPartyId(bankAccount.party_id);
              setName(bankAccount.name);
              setBankId(bankAccount.bank_id);
              setType(bankAccount.type);
              setAccountNumber(bankAccount.account_number);
              setIban(bankAccount.iban);
              setCardNumber(bankAccount.card_number);
          }
      });
    }
  }, [editBankAccountId]);

  return (
    <Modal show={openWindow} onHide={closeWindow} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("bank-account-edit-party-bank-account-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="EditForm" onSubmit={e => {e.preventDefault(); save()}}>
          <div className="row">
            <Form.Group className="mb-3 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-party-bank-account-window.party")}</Form.Label>
              <Form.Select value={partyId} onChange={e => {setPartyId(e.target.value)}}>
                {partyOptions}
              </Form.Select>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-party-bank-account-window.iban")}</Form.Label>
              <div className="row">
                <div className="col pe-1">
                  <Form.Control type="text" dir="ltr" value={iban} onChange={e => {setIban(e.target.value)}}></Form.Control>
                </div>
                <div className="col-auto ps-1">
                  <Button variant="outline-secondary" onClick={checkIBAN}>{i18n.t("bank-account-edit-party-bank-account-window.iban_info")}</Button>
                </div>
              </div>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-party-bank-account-window.name")}</Form.Label>
              <Form.Control type="text" value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-party-bank-account-window.bank")}</Form.Label>
              <Form.Select value={bankId} onChange={e => {setBankId(e.target.value)}}>
                {bankOptions}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-party-bank-account-window.type")}</Form.Label>
              <Form.Select value={type} onChange={e => {setType(e.target.value)}}>
                <option value={"bank_account"}>{i18n.t("bank-account-edit-party-bank-account-window.types.bank_account")}</option>
                {/* <option value={"bon_card"}>{i18n.t("bank-account-edit-party-bank-account-window.types.bon_card")}</option> */}
                <option value={"deposit_card"}>{i18n.t("bank-account-edit-party-bank-account-window.types.deposit_card")}</option>
              </Form.Select>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-party-bank-account-window.account_number")}</Form.Label>
              <Form.Control type="text"  dir="ltr" value={accountNumber} onChange={e => {setAccountNumber(e.target.value)}}></Form.Control>
            </Form.Group>
            <Form.Group className="mb-3 col-lg-6 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-edit-party-bank-account-window.card_number")}</Form.Label>
              <Form.Control type="text" dir="ltr" value={cardNumber} onChange={e => {setCardNumber(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeWindow}>{i18n.t("bank-account-edit-party-bank-account-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="EditForm" >{i18n.t("bank-account-edit-party-bank-account-window.edit_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditPartyBankAccountWindow;